import React from "react";
import { useParams } from "react-router-dom";
import PageContent from "2g-page-content";

import ProduktDetailComponent from "b2b/components/produkt-detail/ProduktDetail";

export function ProduktDetail() {
  const { id } = useParams();

  return (
    <PageContent>
      <ProduktDetailComponent id={id} />
    </PageContent>
  );
}

ProduktDetail.propTypes = {};

export default React.memo(ProduktDetail);
